import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { motion } from 'framer-motion';
import Navigation from '../../Components/Navigation/Navigation';

function Homepage({ onLogout }) {
  const [user, setUser] = useState(null);

  useEffect(() => {
    // localStorage'dan kullanıcı bilgilerini al
    const userData = localStorage.getItem('user');
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      // Kullanıcı bilgisi yoksa login sayfasına yönlendir
      window.location.href = '/';
    }
  }, []);

  const handleLogout = () => {
    if (onLogout) {
      onLogout();
    } else {
      localStorage.removeItem('user');
      window.location.href = '/';
    }
  };

  if (!user) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <Navigation user={user} onLogout={handleLogout} currentPage="home" />
      <Container className="mt-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
        
      </motion.div>
    </Container>
    </>
  );
}

export default Homepage;
